import styled from 'styled-components'

export const MainBox = styled.main`
  flex: 1 0 auto;
`
